module.exports = __webpack_public_path__ + "img/twentyone.33e1e4d0.jpg";